const TableSearch = ({ value, onChange, language }) => (
  <div className="w-full md:w-auto">
    <input
      type="text"
      placeholder={language ? "खोजें..." : "Search..."}
      value={value}
      onChange={onChange}
      className="border rounded px-3 py-2 text-sm w-full md:w-64"
    />
  </div>
);

export default TableSearch;
